const TYPES = {
    GET_APP_CONFIG: 'GET_APP_CONFIG',
    GET_APP_CONFIG_COMPLETE: 'GET_APP_CONFIG_COMPLETE',
    GET_APP_CONFIG_FAILED: 'GET_APP_CONFIG_FAILED'
};

export default {
    TYPES,

    getAppConfig: payload => ({
        type: TYPES.GET_APP_CONFIG,
        payload
    }),

    getAppConfigSuccess: config => ({
        type: TYPES.GET_APP_CONFIG_COMPLETE,
        payload: config
    }),

    getAppConfigFailed: error => ({
        type: TYPES.GET_APP_CONFIG_FAILED,
        payload: {error}
    })
};
